module.exports = __webpack_public_path__ + "img/public/SiteIcons/hostStepIcons/discount.svg?67de5bf5";